import { render, staticRenderFns } from "./FaultsReportWidget.vue?vue&type=template&id=8e35313c&"
import script from "./FaultsReportWidget.vue?vue&type=script&lang=js&"
export * from "./FaultsReportWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports